angular
    .module('MyApp')
    .service('MeusCasosService', ['$resource', '$q', 'SessionData', 'Configs', function($resource, $q, SessionData, Configs) {



    }]);
